import {withStyles} from '@material-ui/core/styles';
import * as React from 'react';
import {Collapse, Typography} from '@material-ui/core';
import Button from "@components/common/button/Button";
import {ITodo, RENEWAL, TODO_TYPE} from '@app-types/websocket/todo.types';
import EditTodoDialog from './EditTodoDialog';
import {IFamilyMember} from '@app-types/websocket/family.types';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import TranslateNew from '@translate/TranslateNew';
import {TodoStyle} from "@components/todo/todo.style";
import {WithStyles} from "@material-ui/styles";
import {Done} from "@material-ui/icons";
import ArchiveIcon from "@components/svg/archiveIcon";
import clsx from "clsx";
import TodoListRow from './TodoListRow';

const tn: TranslateNew = TranslateNew.getInstance();
export const TODO_COLLAPSE_DURATION = 280;

interface IProps extends WithStyles<typeof TodoStyle> {
  myAccountId: number;
  todoData: ITodo;
  classes: any;
  family: IFamilyMember[];
  animateHide?: boolean;
  scheduleParents?: number[];
  scheduleId?: number;
  scrollTime?: number;
  embedded?: boolean;
  listRow?: boolean;
  listActive?: boolean;
  index: number;
  complete: (completed: boolean) => void;
  hide: () => void;
  seen: () => void;
  style?: React.CSSProperties;
}

interface IState {
  showEditModal: boolean;
  seenCalled: boolean;
}

class ToDoItem extends React.Component<IProps, IState> {

  public state = {
    showEditModal: false,
    seenCalled: false,
  };

  private myRef: HTMLDivElement | null = null;

  public componentDidUpdate(prevProps: IProps) {
    if (this.props.listRow) {
      return;
    }
    if (this.state.seenCalled === false && this.props.todoData.seen
      && this.props.todoData.seen.indexOf(this.props.myAccountId) === -1
      && prevProps.scrollTime !== this.props.scrollTime) {
      if (this.isInViewport()) {
        this.setState({seenCalled: true});
        this.props.seen();
      }
    }
  }

  public componentDidMount() {
    if (this.props.listRow) {
      return;
    }
    if (this.state.seenCalled === false && this.props.todoData.seen
      && this.props.todoData.seen.indexOf(this.props.myAccountId) === -1) {
      if (this.isInViewport()) {
        this.setState({seenCalled: true});
        this.props.seen();
      }
    }
  }


  public render() {
    const {classes, todoData, embedded} = this.props;
    const seen = (todoData.seen ? (todoData.seen.indexOf(this.props.myAccountId) > -1) : false);
    let due: Date | null = null;
    let completionDate: string | null = null;
    if (this.props.todoData.dueDate) {
      due = new Date(this.props.todoData.dueDate);
    }
    if (this.props.todoData.completionTime) {
      const date = new Date(this.props.todoData.completionTime);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      completionDate = `${year}-${month}-${day}`;
    }

    if (this.props.listRow) {
      const reducedMotion = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      return (
        <>
          <Collapse in={!this.props.animateHide} collapsedSize={0} unmountOnExit={true}
            timeout={{enter: 0, exit: reducedMotion ? 0 : TODO_COLLAPSE_DURATION}}
            data-todo-collapse={todoData.id}
            style={{width: '100%', flexShrink: 0, minHeight: 0, padding: 0, margin: 0}}>
            <TodoListRow todo={todoData} family={this.props.family} myAccountId={this.props.myAccountId}
              seen={seen} due={due} style={this.props.style}
              active={this.props.listActive !== false && !this.state.showEditModal} markSeen={this.props.seen}
              animateHide={this.props.animateHide} rowRef={(el) => this.myRef = el}
              edit={() => this.setState({showEditModal: !this.state.showEditModal})}
              complete={this.props.complete} hide={this.props.hide} />
          </Collapse>
          {this.renderEditDialog()}
        </>
      );
    }

    const checkboxClassNames = [classes.roundCheckbox];
    if (!!this.props.todoData.completedBy) checkboxClassNames.push(classes.roundCheckboxChecked);
    if (embedded) checkboxClassNames.push(classes.roundCheckboxCompact);

    return (
      <>
        <div
          ref={(el) => this.myRef = el}
          onClick={() => this.setState({showEditModal: !this.state.showEditModal})}
          style={this.props.style}
          className={`${classes.toDoItem} ${seen ? "" : classes.todoUnseen} ${this.props.todoData.type === TODO_TYPE.HANDOVER? classes.handoverList : ""} ${embedded ? classes.embedded : ""} ${this.props.animateHide ? "slide-out-elliptic-right-bck" : ""}`}>
          <div className={classes.cardTop}>
            <div className={classes.titleSection} style={this.props.embedded?{margin:0}:{}}>
              <div style={{display: 'flex', alignItems:'center'}}>
                <div className={classes.avatars} style={{opacity: this.props.todoData.completedBy ? 0.5 : 1,}}>
                  {todoData.assigned && (this.getAvatars(todoData.assigned))}
                </div>
                <Typography variant="h4" color="initial"
                  style={this.props.todoData.completedBy ? {textDecoration: 'line-through', color: 'rgba(0, 0, 0, 0.50)'} : {}}>
                  {todoData.title}
                </Typography>
              </div>
              { /* Checkbox */}
              <div className={clsx(checkboxClassNames)} onClick={(e) => {this.props.complete(!this.props.todoData.completedBy); e.stopPropagation();}}
                >
                <input
                  checked={!!this.props.todoData.completedBy}
                  className={classes.roundCheckboxInput}
                  readOnly={true}
                  type="checkbox"                  
                />
                <Done color="inherit" fontSize="inherit"/>
              </div>
            </div>
            { /* Packlistan repeatability  */
              todoData.renewal && !embedded &&
                <Typography
                    variant="subtitle2"
                    color="initial"
                    style={
                      this.props.todoData.completedBy ? {color: 'rgba(0, 0, 0, 0.50)'} : {}
                    }
                >
                  {todoData.renewal === RENEWAL.NONE ? tn.lang.todoRenewNo : tn.lang.todoRenewHandover}
                </Typography>
            }
            {
              (todoData.completedBy && completionDate)
              && !embedded && (
                <Typography variant="subtitle2" className={classes.completedText}>
                  {(todoData.completedBy === this.props.myAccountId)
                    ? tn.lang.todoYours(completionDate)
                    : tn.lang.todoNotYours(tn.familyMemberName(todoData.completedBy, this.props.family)
                      , completionDate)
                  }
                </Typography>
              )
            }
            { /* Due date */
              due && !(todoData.completedBy && completionDate) && !embedded && (
                <Typography variant="subtitle2" color={(((new Date()).getTime() > due.getTime()
                  && !(this.props.todoData.completedBy)) ? "error" : "initial")}
                >
                  {due.getFullYear() + "-" + (due.getMonth() + 1) + "-" + due.getDate()}
                </Typography>
              )
            }

          </div>
          {/* Desc */
            todoData.description && !(todoData.completedBy && completionDate) && !embedded && (
              <div className={classes.cardMiddle}>
                <div className={classes.todoDesc}>
                  {todoData.description?todoData.description:""}
                </div>
              </div>
            )
          }
          <div className={classes.cardBottom} style={{flex: 1}}>
            {/* Avatar & Archive */}
            {(todoData.completedBy && completionDate && !(embedded) && !todoData.renewal) 
              ?<Button
                size="small"
                variant="text"
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.hide();
                }}
                className={classes.archiveButton}
              >
                <ArchiveIcon color="inherit" fontSize="inherit"/>
                {tn.lang.archive}
              </Button>
              :(todoData.description && this.props.embedded)?<div className={classes.seenBy} style={{flex: 1, justifyContent: 'flex-start'}}>
                {todoData.description}
              </div>
              :<div/>
            }
            { /* Visibility */}
            {todoData.seen && (
              <div className={classes.seenBy}
                   style={{
                      whiteSpace:'nowrap',
                      flex:0,
                      opacity: this.props.todoData.completedBy ? 0.5 : 1,
                   }}>
                {tn.lang.todoSeenBy}
                {this.getSeenAvatar(todoData.seen)}
              </div>
            )}
          </div>
        </div>
        {this.renderEditDialog()}
      </>
    );
  }

  private isInViewport(offset = 0) {
    if (!this.myRef) {
      return false;
    }
    const rect = this.myRef.getBoundingClientRect();
    // console.log("TODOBOX:"+rect.top +" "+rect.bottom+" "+rect.left+" "+rect.right);
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    const viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);

    if (!(rect.left >= 0 && rect.right <= viewWidth)) {
      return false;
    }
    if (!(rect.top >= 0 && (rect.top + 50) <= viewHeight)) {
      return false;
    } // if 50 pixels has been seen thats enough

    return true;
  }

  private getSeenAvatar(accounts: number[]) {
    return accounts.map(accountId => {
      const member = this.props.family.find(m => m.id === accountId);
      if (member) {
        return (
          <ImgAvatar
            key={accountId}
            color={member.color || '#FFFFFF'}
            imgUrl={member.imageAvatar?member.avatarURL:undefined}
            imgName={member.avatar}
            style={{
              width: 10,
              height: 10,
            }}
            altText={member.firstName}
          />
        );
      }
      return null;
    });
  }

  private getAvatars(accounts: number[]) {
    const {embedded} = this.props;
    return accounts.map((accountId, index) => {
      const member = this.props.family.find(m => m.id === accountId);
      if (member) {
        return (
          <ImgAvatar
            key={accountId}
            color={member.color || '#FFFFFF'}
            imgName={member.avatar}
            imgUrl={member.imageAvatar?member.avatarURL:undefined}
            style={{
              width: embedded ? 18 : 25,
              height: embedded ? 18 : 25,
              marginLeft: index > 0 ?(embedded?-9:-15): 0, 
              marginRight: 2,
            }}
            altText={member.firstName}
          />
        );
      }
      return null;
    });
  }

  private handleClose() {
    this.setState({showEditModal: false});
  }

  private renderEditDialog() {
    return (
      <EditTodoDialog
        open={this.state.showEditModal}
        close={() => this.handleClose()}
        scheduleParents={this.props.scheduleParents}
        todo={this.props.todoData}
      />
    );
  }

}

export default withStyles(TodoStyle)(ToDoItem);



// WEBPACK FOOTER //
// ./src/components/todo/todo.item.tsx